import { newEvent } from '../../helpers/event';

interface ItemGroup {
    container: HTMLElement;
    field: HTMLInputElement;
    original_value: string;
}

export class ProtectChanges {
    private inputs: NodeList;
    private container: HTMLElement;
    private items: ItemGroup[] = [];

    constructor() {
        this.container = <HTMLElement>document.getElementById('js-basket');
        this.inputs    = this.container.querySelectorAll('.js-basket__input');

        $.each(this.inputs, ({}, inputField) => {
            const input = inputField as HTMLInputElement;

            // Create our object and store it
            const item        = <HTMLElement>input.closest('.js-basket-item');
            const inputObject = {
                container: item,
                field: input,
                original_value: input.value,
            }
            this.items.push(inputObject);

            // Bind our events
            input.addEventListener('change', () => {
                this.lockBasket(inputObject);
            });

            input.addEventListener('keydown', () => {
                this.lockBasket(inputObject);
            });

            // Reset our changes and make the basket editable again
            const cancelBtn   = <HTMLElement>item.querySelector('.js-basket__cancel-changes');
            if(cancelBtn) {
                cancelBtn.addEventListener('click', () => {
                    this.unlockBasket(inputObject)
                });
            }
        });
    }


    /**
     * Locks the basket so you can only interact with the product that just changed
     * 
     * @private
     * @return void
     */
    private lockBasket(item: ItemGroup): void {

        // Show the overlays to stop any other interaction
        this.container.classList.add('c-basket--has-changed');

        // But make the product interactive
        item.container.classList.add('c-basket__item--has-changed');
    }


    /**
     * Resets the value to it's original, then makes the basket editable again
     * 
     * @private
     * @return void
     */
    private unlockBasket(item: ItemGroup): void {

        // Reset the input value
        item.field.value = item.original_value;
        item.field.dispatchEvent(newEvent('change'));

        // Show the overlays to stop any other interaction
        this.container.classList.remove('c-basket--has-changed');

        // But make the product interactive
        item.container.classList.remove('c-basket__item--has-changed');
    }
}
